module.exports = "\r\n<span class=\"rl-favorite-star\" title=\"Favorite this Page\" ng-click=\"fsVM.Click()\" ng-class=\"{'active': fsVM.active}\"></span"